import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syska } from './Syska-angular';


@Injectable({
  providedIn: 'root'
})
export class SyskaServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Syska();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      KA001: '日期', KA002: '時間', KA003: '公司代號', KA004: '程式代號', KA006: '處理進度', KA007: '工作電腦', KA008: '分類', KA009: '開始時間', KA010: '完成時間', KA011: '處理結果', KA012: '錯誤個數', KA013: '警告個數', KA014: '參數內容', KA015: '使用者代號', KA016: '定時工作代號', KA017: '成功筆數', KA018: '失敗筆數', KA019: 'MAIL通知方式', KA020: 'MAIL帳號', NAME1: 'API名稱'
    };

    this.fieldNames = 'KA001,KA002,KA003,KA004,KA006,KA007,KA008,KA009,KA010,KA011,KA012,KA013,KA014,KA015,KA016,KA017,KA018,KA019,KA020,NAME1';
    this.fieldLengths = { KA001: 8, KA002: 12, KA003: 30, KA004: 20, KA006: 1, KA007: 15, KA008: 20, KA009: 0, KA010: 0, KA011: 0, KA012: 8, KA013: 8, KA014: 4000, KA015: 10, KA016: 14, KA017: 8, KA018: 8, KA019: 1, KA020: 255, NAME1: 255 };
    this.columnDefs = [
      { field: "KA012", headerName: "錯誤個數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "NAME1", headerName: "API名稱", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "KA020", headerName: "MAIL帳號", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "KA019", headerName: "MAIL通知方式", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "KA018", headerName: "失敗筆數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "KA017", headerName: "成功筆數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "KA016", headerName: "定時工作代號", headerTooltip: "", width: 182, cellDataType: "text", },
      { field: "KA015", headerName: "使用者代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "KA014", headerName: "參數內容", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "KA013", headerName: "警告個數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "KA001", headerName: "日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "KA011", headerName: "處理結果", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "KA010", headerName: "完成時間", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "KA009", headerName: "開始時間", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "KA008", headerName: "分類", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "KA007", headerName: "工作電腦", headerTooltip: "", width: 190, cellDataType: "text", },
      { field: "KA006", headerName: "處理進度", headerTooltip: "", width: 80, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "KA005", headerName: "保留", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "KA004", headerName: "程式代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "KA003", headerName: "公司代號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "KA002", headerName: "時間", headerTooltip: "", width: 166, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSKA';
    this.isSys = true;
    this.sqlSelect = `SELECT SYSKA.*  FROM SYSKA`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY KA001,KA002,KA003,KA004`;
    this.keyFields = ['KA001', 'KA002', 'KA003', 'KA004'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['KA001', 'KA002', 'KA003', 'KA004'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Syska): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Syska): Promise<Syska> {
    await super.newRecord(newItem);
    return newItem;
  }




}

